





















































































































































import { Component } from 'vue-property-decorator';
import { Getter } from "vuex-class";
import {ScrollButton} from "wings-ui-components";
import BaseItemsPage from "@/pages/Pages/BaseItemsPage";
import MailNotifyGroupFilter from "@/components/MailNotify/MailNotifyGroupFilter.vue";
import { GroupItem, GroupFilterParams } from '@/store/mailnotify/statistic/types';
import GroupCharts from "@/components/Reports/GroupCharts.vue";

@Component({ components: {MailNotifyGroupFilter, ScrollButton, GroupCharts}})
export default class MailNotifyGroup extends BaseItemsPage<GroupItem> {

  @Getter("mnStatisticGroup") responseItems: any;

  is_show_filter = true;
  is_show_graphics = true;

  currentSort = "date";

  tableFields = this.tableFieldsDefault;

  groupBy = '';
  optionallyGroupBy = '';

  onGroupByChange(data: any) {
    this.groupBy = data.groupBy
    this.optionallyGroupBy = data.optionallyGroupBy
  }

  print(item: string, totalRow: boolean) {
    if (totalRow) return item
    return item ?? this.$t('unnamed')
  }

  getData() {
    return this.responseItems?.messages;
  }

  get tableFieldsDefault() {
    return [
      'transmitted', 'delivered', 'not_delivered', 'read', 'expired', 'failed',  'rejected', 'deferred', 'total', 'partner_price'
    ];
  }

  get totalData() {
    let total = {...this.responseItems?.messages_summary, totalRow: true}
    if (this.groupBy) {
      total.date = this.$t('total')
    } else if (this.optionallyGroupBy) {
      total[this.optionallyGroupBy] = this.$t('total')
    }
    return total
  }

  get compareData() {
    return [...this.queriedData, this.totalData];
  }

}
